/** @jsxImportSource react */
import { useEffect, useState } from 'react'
import { Alert, Link, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { authAPI } from '../api/auth'
import { storeSession } from '../store/slices/authSlice'
import { getErrorMessage } from '../utils/apiErrors'
import AuthCard from '../components/common/AuthCard'

/** Back from Google / Microsoft: /sso/complete#code=…&next=… — trade the one-time code for a session. */
const SsoCompletePage = () => {
  const [error, setError] = useState(null)
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1))
    const code = params.get('code')
    const next = params.get('next')
    window.history.replaceState(null, '', window.location.pathname) // the code works once; don't leave it around
    if (!code) {
      setError('This sign-in link is incomplete.')
      return
    }
    authAPI.ssoExchange(code)
      .then((session) => {
        storeSession(session)
        // a full load, so the app starts signed in; only paths inside the app
        window.location.replace(next && /^\/(?!\/)/.test(next) ? next : '/select-tenant')
      })
      .catch((e) => setError(getErrorMessage(e)))
  }, [])

  return (
    <AuthCard subtitle="Signing you in">
      {error ? (
        <>
          <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
          <Link component={RouterLink} to="/login" variant="body2">Back to sign in</Link>
        </>
      ) : <Typography variant="body2" color="text.secondary">One moment…</Typography>}
    </AuthCard>
  )
}

export default SsoCompletePage
